import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import styles from 'components/Registration/Form/signupStyles.module.css'
import scholarshipicon from '../../assets/scho_digiticon.svg'
import './accordion.css'
import graphicregister from '../../assets/model-registerstep-new.png'
import registergif from '../../assets/Modelhomepage_GIF_new.png'
import backarrow from '../../assets/backtopbtn.svg'
import useGetApi from 'api/useGetApi'
import config from 'config'
import calendaricon from '../../assets/calender_icon_iacst.png'
import { webEngageDob } from 'utils/dateTime'
import { getExamConfig } from 'utils/common'
import { getExamType } from 'utils/common'

const IacstLandingPageTemplate = (props) => {
    const location = useLocation()
    const examType = getExamType()

    const configval = getExamConfig(examType)
    const testSeries = configval.registerTemplate.test_criteria

    const [currentStep, setCurrentStep] = React.useState(1)
    const [signupSuccessDetails, setSignupSuccessDetails] = React.useState({
        isSignupSuccessful: false,
    })
    const [showFailureMessage, setShowFailureMessage] = useState(false)

    const [defaultUserInfo, setDefaultUserInfo] = React.useState(() => {
        const baseInfo = {
            studentName: '',
            email: '',
            dob: '',
            mobileNumber: '',
            prevSignupAttempt: 0,
        }
        return baseInfo
    })

    const [isNewUser, setIsNewUser] = React.useState(true)

    const [isVisible, setIsVisible] = useState(false)
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 700) {
                setIsVisible(true)
            } else {
                setIsVisible(false)
            }
        }

        window.addEventListener('scroll', handleScroll)
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    const queryParams = new URLSearchParams(location.search)
    const sf_id = queryParams.get('sf_id')

    const signupSuccessfulDetails = {
        roll_number: queryParams.get('roll_no'),
        dob: queryParams.get('dob'),
        exam_date: queryParams.get('exam_date'),
        dashboard_link: `/?roll_no=${queryParams.get(
            'roll_no',
        )}&dob=${queryParams.get('dob')}`,
    }

    const registration = queryParams.get('registeration')
    let status = queryParams.get('status')
    useEffect(() => {
        if (registration === 'success') {
            setSignupSuccessDetails({
                isSignupSuccessful: true,
                roll_number: signupSuccessfulDetails.roll_number,
                dob: signupSuccessfulDetails.dob,
                exam_date: signupSuccessfulDetails.exam_date,
            })
        }
    }, [registration, signupSuccessfulDetails.dob, signupSuccessfulDetails.exam_date, signupSuccessfulDetails.roll_number])

    // useEffect(() => {
    //     if (sf_id) {
    //         setCurrentStep(2)

    //         getSfUserData(true)
    //     }
    // }, [sf_id])

    // const { data: sfUserData, setEnabled: getSfUserData } = useGetApi(
    //     config.SF_LEAD_INFO + '/?sf_id=' + sf_id,
    //     '',
    //     false,
    // )

    // console.log('sfUserData: ', sfUserData)

    // useEffect(() => {
    //     if (sfUserData?.success && sfUserData?.student_details?.length > 0) {
    //         const student = sfUserData.student_details[0]
    //         console.log('Student 1 : ', student)

    //         localStorage.setItem('studentInfo', JSON.stringify(student))
    //         console.log('Student : ', student)
    //         setIsSfNewUser(true)
    //         setIsNewUser(false)
    //         setDefaultUserInfo({
    //             studentName: student.student_name || '',
    //             email: student.student_email || '',
    //             dob: student.student_dob || '',
    //             mobileNumber: student.mobile_no || '',
    //             prevSignupAttempt: student.registration_count || 0,
    //         })
    //     }
    // }, [sfUserData])

    const ph_no = queryParams.get('mobile')

    const { data: userData, setEnabled: getUserInfo } = useGetApi(
        config.LEAD_INFO + '/?mobile_no=' + ph_no,
        '',
        false,
    )

    useEffect(() => {
        if (userData?.success && userData?.student_details?.length > 0) {
            const student = userData.student_details[0] // Extract the first student detail

            setIsNewUser(false)
            setDefaultUserInfo({
                studentName: student.student_name || '',
                email: student.student_email || '',
                dob: student.student_dob || '',
                mobileNumber: student.mobile_no || '',
                classStream: student.classstream || '',
                prevSignupAttempt: student.registration_count || 0,
            })
        }
    }, [userData])

    useEffect(() => {
        if (status === 'failure' && ph_no) {
            const userInfo_data = localStorage.getItem('user_info') ? JSON.parse(localStorage.getItem('user_info')) : ""
            const examInfo_data = localStorage.getItem('exam_info') ? JSON.parse(localStorage.getItem('exam_info')) : ""
            if ((userInfo_data && examType == 'MOCK-NEET') || examType == 'IAT' || examType == "MOCK-JEE" && localStorage.getItem('user_info') && localStorage.getItem('exam_info')) {
                
                window.webengage.track(examType + '7_payment_status_failure', {
                    'utm parameters': localStorage.getItem('utmParams')
                        ? localStorage.getItem('utmParams')
                        : '',
                    'mobile number': userInfo_data.mobileNumber
                        ? userInfo_data.mobileNumber
                        : '',
                    board: examInfo_data.schoolBoard.value
                        ? examInfo_data.schoolBoard.value
                        : '',
                    student_name: userInfo_data.studentName
                        ? userInfo_data.studentName
                        : '',
                    dob: webEngageDob(userInfo_data.dob)
                        ? webEngageDob(userInfo_data.dob)
                        : '',
                    email: userInfo_data.email ? userInfo_data.email : '',
                    class: examInfo_data.classStream.class
                        ? examInfo_data.classStream.class
                        : '',
                    stream: examInfo_data.classStream.stream
                        ? examInfo_data.classStream.stream
                        : '',
                    state: userInfo_data.state ? userInfo_data.state : '',
                    exam_mode: 'Offline',
                    'branch name': examInfo_data.centre.label
                        ? examInfo_data.centre.label
                        : '',
                    exam_date: new Date(examInfo_data.dateOfExam + 'T03:30:00.000Z')
                        ? new Date(examInfo_data.dateOfExam + 'T03:30:00.000Z')
                        : '',
                    'branch code': examInfo_data.centre.centreCode
                        ? examInfo_data.centre.centreCode
                        : '',
                    city: userInfo_data.city ? userInfo_data.city : '',
                    payment_status: 'failure',
                    failure_reason: '',
                    exam_type: examType,
                    exam_fee: localStorage.getItem('exam_fee')
                        ? Number(localStorage.getItem('exam_fee'))
                        : '',
                    pincode: userInfo_data.pincode ? userInfo_data.pincode : '',
                    psid: localStorage.getItem('user_psid')
                        ? localStorage.getItem('user_psid')
                        : '',
                })
            }

            setShowFailureMessage(true) // Show the failure message
            setCurrentStep(0)
        }
    }, [getUserInfo, ph_no, status])

    return (
        <>
            <div className="">
                {isVisible && (
                    <div className={styles.backtopbtn}>
                        <a href="#backtop">
                            Back to top < img src={backarrow} alt="" />
                        </a >
                    </div >
                )}
                {/* -------------content section start*/}
                < section className="bg-white">
                    <div className="">
                        <>
                            {/*------- criteria section */}
                            <div
                                className={`container ${styles.iacst_criteriasection}`}
                            >
                                {
                                    testSeries &&
                                    testSeries.map((obj, index) => {
                                        return (
                                            <div
                                                key={index}
                                                className={`${styles.criteriabox}`}
                                            >
                                                <h2>{obj.mainheading}</h2>
                                                {obj.content.map(
                                                    (contentItem, contentIndex) => (
                                                        <div
                                                            key={contentIndex}
                                                            className={`${styles.criterialist}`}
                                                        >
                                                            <div
                                                                className={`${styles.listingsection}`}
                                                            >
                                                                {contentItem.headings.map(
                                                                    (
                                                                        heading,
                                                                        headingIndex,
                                                                    ) => (
                                                                        <div
                                                                            key={
                                                                                headingIndex
                                                                            }
                                                                            className={`${styles.parent_listing}`}
                                                                            style={{
                                                                                border:
                                                                                    headingIndex ==
                                                                                        2
                                                                                        ? 'none'
                                                                                        : '',
                                                                            }}
                                                                        >
                                                                            <div>
                                                                                <img
                                                                                    src={
                                                                                        heading.imgicon
                                                                                    }
                                                                                    alt=''
                                                                                />
                                                                            </div>
                                                                            <div>
                                                                                <h6>
                                                                                    {
                                                                                        heading.mode
                                                                                    }
                                                                                </h6>
                                                                                <p>
                                                                                    {
                                                                                        heading.details
                                                                                    }
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    ),
                                                                )}
                                                            </div>
                                                        </div>
                                                    ),
                                                )}
                                            </div>
                                        )
                                    })
                                }
                            </div >
                            {/*------- criteria section */}
                            {/* validity section */}
                            <div className="container px-3">
                                <div
                                    className={`${styles.validity_section} d-flex justify-content-between align-items-center`}
                                >
                                    <div className={`${styles.validity_text}`}>
                                        <p>
                                            iACST Scholarship(s) are valid for{' '}
                                            <span>30 days</span> only.
                                        </p>
                                    </div>
                                    <div className={`${styles.calendaricon}`}>
                                        <img src={calendaricon} alt='calendericon' />
                                    </div>
                                </div>
                            </div>
                            {/* validity section */}
                            {/* ------ register section */}
                            <div
                                className={`container ${styles.register_wrapper}`}
                                id="how-it-works"
                            >
                                <div className={`${styles.reg_inner}`}>
                                    <div className={`${styles.reg_imagestatic}`}>
                                        <img src={graphicregister} alt="" />
                                    </div>
                                    <div className={`${styles.reg_imagegif}`}>
                                        <img
                                            src={registergif}
                                            alt=""
                                            className="img-fluid"
                                        />
                                        <div
                                            className={`${styles.registration_section}`}
                                        ></div>
                                    </div>

                                    <div
                                        className={`${styles.registration_section}`}
                                    >
                                        <div className={`${styles.reg_content}`}>
                                            <h3>How to register?</h3>
                                            <p className={`${styles.reg_subtitle}`}>
                                                In just 3-step process
                                            </p>
                                            <div className={`${styles.reg_steps}`}>
                                                <div
                                                    className={`${styles.reg_step}`}
                                                >
                                                    <div
                                                        className={`${styles.reg_step_number}`}
                                                    >
                                                        1
                                                    </div>
                                                    <p>Verify your mobile number</p>
                                                </div>
                                                <div
                                                    className={`${styles.reg_step}`}
                                                >
                                                    <div
                                                        className={`${styles.reg_step_number}`}
                                                    >
                                                        2
                                                    </div>
                                                    <p>
                                                        Submit your academic details
                                                    </p>
                                                </div>
                                                <div
                                                    className={`${styles.reg_step}`}
                                                >
                                                    <div
                                                        className={`${styles.reg_step_number}`}
                                                    >
                                                        3
                                                    </div>
                                                    <p>
                                                        Select preferred exam date
                                                        and time slot
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div >
                            </div >
                            {/* ------ register section */}
                            {/* -----scholarship figure */}
                            <div
                                className={`container ${styles.scholarships_wrapper}`}
                            >
                                <div className={`${styles.scholarships_content}`}>
                                    <div className={`${styles.scholarships_digits}`}>
                                        <h4>155,300+</h4>
                                        <p>
                                            Scholarships <br />
                                            awarded last year
                                        </p>
                                    </div>
                                    <div>
                                        <img src={scholarshipicon} alt="" />
                                    </div>
                                </div>
                            </div>
                        </>
                    </div >
                </section >
            </div >
        </>
    )
}

export default IacstLandingPageTemplate
